import React, {type SFC} from "react";
import { FormattedMessage } from "react-intl";
import RaangeLabel, {IRaangeLabelProps} from "../shared/components/RaangeLabel";

export const HumanoidLabel: SFC<Omit<IRaangeLabelProps, "fa">> = (props) => {
  return (
    <RaangeLabel fa="robot" {...props}>
      <FormattedMessage id="dispatches.humanoid" />
    </RaangeLabel>
  );
};
